const defaultItems = ["Item 1", "Item 2"];

export default class CustomToggleControl {
  constructor(options = {}) {
    this.items = options.items || defaultItems;
    this.onChange = options.onChange;
    this.activeItem = options.defaultActiveItem || null;
    // Name of the toggle instance
    this.instanceName = options.id || "lip-default";
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition() {
    const defaultPosition = "top-right";
    return defaultPosition;
  }

  changeActiveItem(item) {
    if (this.items.indexOf(item) === -1 || this.activeItem === item) {
      return;
    }

    [].forEach.call(this.nodes, (btn) => {
      if (btn.textContent === item) {
        btn.classList.add("-active");
      } else {
        btn.classList.remove("-active");
      }
    });

    this.activeItem = item;
  }

  /**
   * Convenience method to toggle enabled/disabled state of any given control.
   * @param {*} item The toggle control item text
   * @param {*} disabled Boolean flag indicated enabled/disabled state of the item(button)
   */
  setItemState(item, disabled = false) {
    if (this.items.indexOf(item) === -1) {
      return;
    }

    [].forEach.call(this.nodes, (btn) => {
      if (btn.textContent === item) {
        btn.disabled = disabled;
      }
    });
  }

  insertControls() {
    this.container = document.createElement("div");
    this.container.classList.add("mapboxgl-ctrl");
    this.container.classList.add("mapboxgl-ctrl-group");
    this.container.classList.add("mapboxgl-ctrl-styles"); // To copy styles from default style switcher
    this.container.classList.add(`${this.instanceName}-custom-toggle`);
    this.nodes = [];

    this.items.forEach((item) => {
      const node = document.createElement("button");
      node.setAttribute("type", "button");
      node.textContent = item;

      if (item === this.activeItem) {
        node.classList.add("-active");
      }

      node.addEventListener("click", () => {
        if (node.classList.contains("-active")) return;
        [].forEach.call(this.nodes, (btn) => {
          btn.classList.remove("-active");
        });
        this.activeItem = item;
        if (this.onChange) this.onChange(item);
        node.classList.add("-active");
      });

      this.nodes.push(node);
      this.container.appendChild(node);
    });
  }

  onAdd(map) {
    this.map = map;
    this.insertControls();
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
    this.activeItem = null;
  }
}
